import cn from 'classnames'
import { FC } from 'react'

import styles from './BorderDecoration.module.scss'

interface IBorderDecorationProps {
  isAdd: boolean
  isRemove: boolean
}

export const BorderDecoration: FC<IBorderDecorationProps> = ({ isAdd, isRemove }) => {
  if (!isAdd && !isRemove) {
    return null
  }

  return (
    <svg
      className={styles.borderDecoration}
      viewBox="0 0 100 60"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        className={cn(styles.borderPath, {
          [styles.addPath]: isAdd,
          [styles.removePath]: isRemove,
        })}
        d="
    M 12 2
    H 70

    M 90 14
    V 46
    Q 90 58 78 58
    H 14
    Q 2 58 2 46
    V 14
    Q 2 2 14 2
  "
      />
    </svg>
  )
}
